import { Link } from '@remix-run/react';

import { useRoutePath } from '~/hooks/useRoutePath';
import { TaxonMiniatureProps } from '~/types/Taxon';

const TaxonMiniature = ({ taxon }: { taxon: TaxonMiniatureProps }) => {
  const routePath = useRoutePath();
  return (
    <div className="taxon-miniature">
      <Link to={routePath('category', taxon.slug)} className="taxon-miniature__link" aria-label={taxon.title} />
      <div className="taxon-miniature__image">
        {taxon.image && (
          <img
            src={taxon.image || '/assets/images/category-placeholder.png'}
            alt={taxon.title}
            className="taxon-miniature__image"
            loading="eager"
            fetchpriority="low"
            decoding="async"
            width={88}
            height={88}
          />
        )}
      </div>
      <p className="taxon-miniature__name">{taxon.title}</p>
    </div>
  );
};

export default TaxonMiniature;
